import React, { useState } from 'react'
import { PlusOutlined, PrinterOutlined } from "@ant-design/icons";
import {
    Drawer,
    Button,
    PageHeader,
} from "antd";
import commonUtility from "../../utility/Utils";
// import { HOLIDAY_LIST_PRINT_URL } from "../../utility/URL";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import { DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import BankEntry from '../../components/masters/Bank/BankEntry';
import BankList from '../../components/masters/Bank/BankList';

const Bank = () => {
    const [visible, setVisible] = useState(false);
    const [bankAddData, setBankAddData] = useState({
        bank_id: 0,
        bank_name: '',
        is_active: 'Y',
        mode: "ADD"
    })
    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };

    return (
        <div className="inside-main-content">
            <AdminBreadCrumb />

            <div className="box-style">
                <PageHeader
                    ghost={false}
                    onBack={() => window.history.back()}
                    title="Bank"
                    subTitle=""
                    extra={[
                        <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
                            <PlusOutlined /> Add
                        </Button>,
                    ]}
                ></PageHeader>

                <Drawer
                    title="Add new Bank"
                    width={DEFAULT_MASTER_DRAWER_WIDTH}
                    onClose={onClose}
                    visible={visible}
                    bodyStyle={{
                        paddingBottom: 80,
                    }}
                    destroyOnClose={true}
                    closeIcon={<><DrawableCloseIcon /></>}
                >
                    <BankEntry
                        data={bankAddData}
                        onDrawerClose={onClose}
                    />
                </Drawer>

                <div className="tableView">
                    <div className="form-content">
                        <BankList />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Bank